import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { sendCampaign } from '@/lib/venue/campaignApi'
import type { VenueCampaignSendResult } from '@/lib/venue/campaignTypes'

import { campaignDetailQueryKey } from './useCampaignDetail'

/**
 * 발송 실행(#715 §D-1) — "발송 확인 모달" 흐름의 2단계.
 *
 * 🚨 `202`(통과)·`200`(차단) 둘 다 `mutationFn`이 정상 반환한다 — 호출부가 `data.dispatched`로 갈라야
 * 한다(예외로 판단하지 않는다).
 *
 * 성공(dispatched 여부 무관 — 차단이어도 캠페인은 `BLOCKED`로 저장된 사실이 바뀐 것)하면 요약·목록·
 * 상세 쿼리를 무효화한다. 상세는 아직 없는 campaignId일 수 있어(작성 직후) 접두사로 넓게 지운다.
 */
export function useSendCampaign(venueId: string) {
  const queryClient = useQueryClient()

  return useMutation<VenueCampaignSendResult, ApiError, number>({
    mutationFn: (campaignId) => sendCampaign(venueId, campaignId),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: ['venue', venueId, 'campaign-summary'] })
      void queryClient.invalidateQueries({ queryKey: ['venue', venueId, 'campaigns'] })
      void queryClient.invalidateQueries({ queryKey: campaignDetailQueryKey(venueId, data.campaignId) })
    },
  })
}
